<template>
  <v-row>
    <v-col cols="11" class="pb-1 pr-0">
      <TextFieldComponent v-model="search" placeholder="Search" @input="searchTheData()" flat
        append-inner-icon="mdi-magnify">
      </TextFieldComponent>
    </v-col>
    <v-col cols="1" class="pl-0 pt-4" style="padding-left: 3px !important">
      <span><v-tooltip activator="parent" location="bottom">Add</v-tooltip><v-icon size="28px" class="plus-icon"
          @click="openDialog">mdi-plus-circle
        </v-icon></span>
    </v-col>
  </v-row>
  <v-row no-gutters dense class="ma-1">
    <v-col cols="12">
      <v-card style="height: 70vh !important; overflow-y: auto; border-radius: 12px">
        <v-list density="compact">
          <v-list-item :class="{ active: item.isActive }" class="mousehover" v-for="(item, index) in localDetailsData"
            :key="item.name" @click="setSelected(item, index)">
            <div class="d-flex" style="justify-content: space-between">
              <span :class="{ 'pl-8': item.data_type !== 'object' }">{{
                item.label
              }}</span>
              <span v-if="item.computed_expression !== null && item.computed_expression !== 'null'"
                style="color: red; font-weight: 400" class="mr-5">cc</span>
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
  </v-row>
  <v-dialog persistent v-model="dialog" width="600px">
    <addDataModelDetail @close-dialog="closeDialog" :modelId="localDetailsData[0]?.model_id || Model_id" />
  </v-dialog>
</template>
<script>
import { TextFieldComponent } from "@tiburadev/vue-comp3";
import addDataModelDetail from "./addDataModelDetail.vue";

export default {
  components: {
    TextFieldComponent,
    addDataModelDetail
  },
  props: ["detailsData","detailsBackData"],
  data() {
    return {
      search: null,
      dialog: false,
      localDetailsData: this.detailsData.map(item => ({ ...item }))
    }
  },
  computed: {
    Model_id() {
      return this.$route?.query?.model_id;
    }
  },
  watch: {
    detailsData: {
      handler(newVal) {
        this.localDetailsData = newVal.map(item => ({ ...item }));
      },
      deep: true
    }
  },
  methods: {
    searchTheData() {
      if (this.search && this.search.length > 0) {
        let searchStr = new RegExp(this.search, "gi");
        this.localDetailsData = this.detailsBackData.filter((ele) => {
          return (
            ele.label.search(searchStr) > -1 ||
            ele.column_name.search(searchStr) > -1
          );
        }).map(item => ({ ...item }));
      } else {
        this.localDetailsData = this.detailsBackData.map(item => ({ ...item }));
      }
    },
    setSelected(item, $index) {
      this.localDetailsData.forEach((e, i) => {
        if (i == $index) {
          e.isActive = true;
        } else {
          e.isActive = false;
        }
      });
      this.$emit("selecthandle", item);
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.$emit("refershData");
    }
  }
}
</script>
<style scoped>
.mousehover:hover {
  background-color: #0068b3;
  color: white;
}

.active {
  background-color: #0068b3;
  color: white;
}

>>>.v-list-item--density-compact.v-list-item--one-line {
  min-height: 45px !important;
}

>>>.v-list {
  padding: 0px !important;
}
</style>
